import { render, staticRenderFns } from "./SearchPage.vue?vue&type=template&id=6d3aae7e"
import script from "./SearchPage.vue?vue&type=script&lang=js"
export * from "./SearchPage.vue?vue&type=script&lang=js"
import style0 from "./SearchPage.vue?vue&type=style&index=0&id=6d3aae7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports